import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { getUser, saveUserDetail } from '../../api/UserClient';
import DatePicker from './form/DatePicker';
import FormField from './form/FormField';
import GenderSelect from './form/GenderSelect';
import PrefectureSelect from './form/PrefectureSelect';
import UserNameField from './form/UserName';
import UserNameKanaField from './form/UserNameKana';
import Notification from './Notification';
const UserDetailDefault = {
    id: 0,
    storeId: 0,
    name: "",
    firstName: "",
    lastName: "",
    nameKana: "",
    firstNameKana: "",
    lastNameKana: "",
    zipcode: "",
    prefectureCode: "",
    prefectureName: "",
    address1: "",
    address2: "",
    tel: "",
    email: "",
    birthday: "",
    companyName: "",
    gender: "",
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
};
const UserDetailComponent = () => {
    const [userDetail, setUserDetail] = useState(UserDetailDefault);
    const userDetailRef = useRef(UserDetailDefault);
    const [notification, setNotification] = useState("");
    const [errors, setErrors] = useState({});
    useEffect(() => {
        getUser().then(response => {
            const data = response.data.userDetail;
            if (data) {
                userDetailRef.current = data;
                setUserDetail(data);
            }
        });
    }, []);
    const handleSubmit = useCallback(() => {
        userDetail.updatedAt = null;
        userDetail.createdAt = null;
        setErrors({});
        saveUserDetail(userDetail).then(updateResult => {
            setUserDetail(updateResult.data);
            setNotification("お客様情報を設定しました");
            window.scrollTo({ top: 0, behavior: 'auto' });
            setTimeout(() => {
                setNotification("");
            }, 10000);
        }).catch(e => {
            if (e.response.data) {
                setErrors(e.response.data);
            }
        });
    }, [userDetail]);
    const handleInput = useCallback((fieldName, value) => {
        console.log(`${fieldName} => ${value}`);
        userDetailRef.current[fieldName] = value;
        setUserDetail(userDetailRef.current);
    }, []);
    return (_jsxs("div", Object.assign({ className: "content mb3 form-container" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u304A\u5BA2\u69D8\u60C5\u5831"] }), void 0),
            _jsx("div", Object.assign({ class: "notification" }, { children: "\u304A\u5BA2\u69D8\u60C5\u5831\u3092\u8A2D\u5B9A\u9802\u304F\u4E8B\u3067\u3001\u8CFC\u5165\u6642\u306B\u5FC5\u8981\u306A\u60C5\u5831\u304C\u81EA\u52D5\u5165\u529B\u3055\u308C\u307E\u3059" }), void 0),
            _jsx(UserNameField, { onInput: handleInput, value: userDetail, errors: errors }, void 0),
            _jsx(UserNameKanaField, { onInput: handleInput, value: userDetail, errors: errors }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "companyName", placeHolder: "\u682A\u5F0F\u4F1A\u793E\u30D5\u30A1\u30FC\u30B9\u30C8\u30C7\u30A3\u30B0\u30EA\u30FC", inputType: "text", onInput: handleInput, errors: errors, label: "\u4F01\u696D\u540D" }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "zipcode", placeHolder: "141-0022", inputType: "text", onInput: handleInput, errors: errors, label: "\u90F5\u4FBF\u756A\u53F7" }, void 0),
            _jsx(PrefectureSelect, { onInput: handleInput, value: userDetail, errors: errors }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "address1", placeHolder: "\u54C1\u5DDD\u533A\u6771\u4E94\u53CD\u75301-22-6", inputType: "text", onInput: handleInput, errors: errors, label: "\u5E02\u533A\u753A\u6751" }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "address2", placeHolder: "\u4E94\u53CD\u7530\u3055\u304F\u3089\u30D3\u30EB9F", inputType: "text", onInput: handleInput, errors: errors, label: "\u756A\u5730\u4EE5\u4E0B" }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "tel", placeHolder: "0364096769", inputType: "tel", onInput: handleInput, errors: errors, label: "\u96FB\u8A71\u756A\u53F7" }, void 0),
            _jsx(FormField, { value: userDetail, fieldName: "email", placeHolder: "info@firstdeg.com", inputType: "email", onInput: handleInput, errors: errors, label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" }, void 0),
            _jsx(GenderSelect, { value: userDetail, errors: errors, onInput: handleInput }, void 0),
            _jsx(DatePicker, { value: userDetail, fieldName: "birthday", inputType: "text", onInput: handleInput, errors: errors, label: "\u751F\u5E74\u6708\u65E5" }, void 0),
            _jsx(Notification, { message: notification }, void 0),
            _jsx("button", Object.assign({ type: "button", class: "button button__primary button__block button__md", onClick: handleSubmit }, { children: "\u304A\u5BA2\u69D8\u60C5\u5831\u3092\u8A2D\u5B9A" }), void 0)] }), void 0));
};
export default UserDetailComponent;
